import {
  type AccountantSignin,
  signinAccountant,
} from 'api/v3/access/accountantsAuth';
import { useMutation } from 'react-query';

interface UseExpertSigninOptions {
  ignoreToast?: boolean;
}

const useExpertSignin = ({
  ignoreToast = false,
}: UseExpertSigninOptions = {}) => {
  return useMutation({
    mutationFn: (values: AccountantSignin) =>
      signinAccountant(values, { ignoreToast }),
  });
};

export default useExpertSignin;
